// extracted by mini-css-extract-plugin
export default {"OtpContainer":"style_OtpContainer__-mzXu","content":"style_content__0Axj0","OtpContainerInput":"style_OtpContainerInput__khxEp"};